import { createContext, useContext, useRef } from 'react';

const FileContext = createContext(null);

function FileContextProvider({ children }) {
  const filesRef = useRef({});

  const addRawFile = (id, file) => {
    filesRef.current[id] = file;
  };

  const getRawFile = (id) => {
    return filesRef.current[id] || null;
  };

  const removeRawFile = (id) => {
    delete filesRef.current[id];
  };

  return (
    <FileContext.Provider value={{ addRawFile, getRawFile, removeRawFile }}>
      {children}
    </FileContext.Provider>
  );
}

export { FileContextProvider };
export { FileContextProvider as FileProvider };

export function useFileContext() {
  const ctx = useContext(FileContext);
  if (!ctx) throw new Error('useFileContext must be used inside FileProvider');
  return ctx;
}